import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssButtonComponent } from '../button/button.component';

@Component({
  selector: 'umss-list-item',
  standalone: true,
  imports: [CommonModule, UmssButtonComponent],
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})
export class UmssListItemComponent {
  // Content props
  @Input({ required: true }) title!: string;
  @Input() subtitle?: string | null;

  // Action button props
  @Input() actionLabel?: string;
  @Input() actionVariant:
    | 'Primary'
    | 'Secondary'
    | 'Destructive'
    | 'Ghost'
    | 'Outline' = 'Outline';
  @Input() actionSize: 'Mini' | 'Small' | 'Regular' | 'Large' = 'Regular';
  @Input() actionDisabled: boolean = false;
  @Input() actionLoading: boolean = false;
  @Input() actionLeftIconName?: string;
  @Input() actionRightIconName?: string;
  @Input() actionIconSize?: string;
  @Input() showAction: boolean = true;
  @Input() titleInline: boolean = true;

  @Output() actionClicked = new EventEmitter<void>();

  get shouldShowAction(): boolean {
    return this.showAction && !!this.actionLabel;
  }

  onActionClick(): void {
    if (!this.actionDisabled && !this.actionLoading) this.actionClicked.emit();
  }
}
